import { render, staticRenderFns } from "./KtvEditMessage.vue?vue&type=template&id=1ce8399b&scoped=true"
import script from "./KtvEditMessage.vue?vue&type=script&lang=js"
export * from "./KtvEditMessage.vue?vue&type=script&lang=js"
import style0 from "./KtvEditMessage.vue?vue&type=style&index=0&id=1ce8399b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce8399b",
  null
  
)

export default component.exports